import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["messageRender", "id", "onChange", "render", "className", "onUpdate", "placement", "placeholder", "size", "value", "width", "widthAdaptive", "noBorder", "disabled", "operations", "adjustMainSize", "isValueEqual", "data-component-name"],
    _excluded2 = ["selector", "renderMessageProps", "confirmButtons"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { isValidElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Dropdown from '../Dropdown';
import BasicSelect from '../BasicSelect';
import ErrorBoundary from '../ErrorBoundary';
import ConfigConsumerProvider from '../ConfigConsumerProvider';
import DropdownButtonPanel from '../DropdownButtonPanel';
import { getLocale } from '../locale';
import Message from '../Message';
import Button from '../Button';
import { getValue } from '../tools/util';
var PRE_VALUE = Symbol('preValue');

var Select = /*#__PURE__*/function (_PureComponent) {
  _inherits(Select, _PureComponent);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);
    _this.cxt = {
      state: {}
    };
    _this.valueKey = _this.props.valueKey;
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // 如果valueKey更新，重置context
      if (this.valueKey !== this.props.valueKey) {
        this.cxt = {
          state: {}
        };
        this.valueKey = this.props.valueKey;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          messageRender = _this$props.messageRender,
          id = _this$props.id,
          onChange = _this$props.onChange,
          _render2 = _this$props.render,
          className = _this$props.className,
          _onUpdate = _this$props.onUpdate,
          placement = _this$props.placement,
          placeholder = _this$props.placeholder,
          size = _this$props.size,
          value = _this$props.value,
          width = _this$props.width,
          widthAdaptive = _this$props.widthAdaptive,
          noBorder = _this$props.noBorder,
          disabled = _this$props.disabled,
          operations = _this$props.operations,
          adjustMainSize = _this$props.adjustMainSize,
          isValueEqual = _this$props.isValueEqual,
          trackComponentName = _this$props['data-component-name'],
          other = _objectWithoutProperties(_this$props, _excluded),
          cxt = this.cxt;

      return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
        size: size
      }, function (_ref) {
        var locale = _ref.locale;
        return /*#__PURE__*/React.createElement(Dropdown, {
          "data-component-name": trackComponentName,
          id: id,
          placement: {
            left: 'bottomLeft',
            right: 'bottomRight'
          }[placement],
          onUpdate: function onUpdate(e) {
            _onUpdate(e, cxt);
          },
          className: classNames('jmtd-select', className),
          adjustMainSize: adjustMainSize,
          render: function render(_ref2) {
            var open = _ref2.open,
                setOpen = _ref2.setOpen,
                triggerNode = _ref2.triggerNode;

            if (open && !_this2.lastOpen) {
              delete cxt.value;

              if (cxt[PRE_VALUE]) {
                cxt.value = cxt[PRE_VALUE];
              }

              delete cxt[PRE_VALUE];
            }

            _this2.lastOpen = open;

            var update = function update() {
              var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var valueChanged = 'value' in result && cxt.value !== result.value; // 计算值是否变化

              Object.assign(cxt, result);

              if (!open && result.value) {
                cxt[PRE_VALUE] = result.value;
              }

              if (valueChanged) {
                _this2.renderByValueChanged = true;
              }

              _this2.forceUpdate();
            };

            var dropdownButtonPanel;

            var _render = _render2({
              locale: locale,
              open: open,
              setOpen: setOpen,
              change: function change() {
                var _cxt$value;

                var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_cxt$value = cxt.value) !== null && _cxt$value !== void 0 ? _cxt$value : value;

                if (!isValueEqual(v, value)) {
                  onChange(v);
                }
              },
              update: update,
              state: cxt.state,
              value: 'value' in cxt && open ? cxt.value : value,
              triggerNode: triggerNode
            }, _objectSpread({
              width: width
            }, other)),
                selector = _render.selector,
                renderMessageProps = _render.renderMessageProps,
                confirmButtons = _render.confirmButtons,
                otherResult = _objectWithoutProperties(_render, _excluded2); // 处理消息


            if (_this2.renderByValueChanged && messageRender) {
              var renderedMessageProps = messageRender(_objectSpread({
                value: cxt.value
              }, renderMessageProps));

              if (renderedMessageProps) {
                _this2.messageOpen = true;
                _this2.messageProps = renderedMessageProps; // 设置消息隐藏倒计时

                window.clearTimeout(_this2.hideMessageHandle);
                _this2.hideMessageHandle = window.setTimeout(function () {
                  _this2.messageOpen = false;

                  _this2.forceUpdate();
                }, 3000);
              } else {
                _this2.messageOpen = false;
              }
            }

            _this2.renderByValueChanged = false;

            if (confirmButtons || operations !== null && operations !== void 0 && operations.length) {
              dropdownButtonPanel = /*#__PURE__*/React.createElement(DropdownButtonPanel, {
                left: operations && operations.map(function (_ref3, i) {
                  var operationLabel = _ref3.label,
                      onClick = _ref3.onClick,
                      optionDisabled = _ref3.disabled,
                      optionValue = _ref3.value;
                  return /*#__PURE__*/React.createElement(Button, {
                    key: i,
                    size: "mini",
                    semantic: "primary",
                    link: true,
                    disabled: optionDisabled,
                    className: "jmtd-select-fast-button",
                    onClick: onClick ? function () {
                      onClick({
                        setOpen: setOpen
                      });
                    } : function () {
                      var _cxt$value2;

                      update({
                        value: getValue(optionValue, (_cxt$value2 = cxt.value) !== null && _cxt$value2 !== void 0 ? _cxt$value2 : value, _this2.props)
                      });

                      if (!other.showConfirm) {
                        setOpen(false);
                      }
                    }
                  }, operationLabel);
                })
              }, confirmButtons);
            } // selector元素


            var selectorElement;

            if ( /*#__PURE__*/isValidElement(selector)) {
              selectorElement = selector;
            } else {
              var Selector = selector.Component,
                  selectorProps = selector.props;
              selectorElement = /*#__PURE__*/React.createElement(Selector, _extends({
                width: width,
                widthAdaptive: widthAdaptive,
                noBorder: noBorder,
                placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : getLocale(locale).common.pleaseSelect,
                open: open,
                disabled: disabled
              }, selectorProps));
            }

            return _objectSpread({
              exclusive: true,
              children: selectorElement,
              otherChildren: /*#__PURE__*/React.createElement(Message, _extends({
                open: _this2.messageOpen,
                onClose: function onClose() {
                  _this2.messageOpen = false;

                  _this2.forceUpdate();
                }
              }, _this2.messageProps)),
              dropdownButtonPanel: dropdownButtonPanel
            }, otherResult);
          }
        });
      }));
    }
  }]);

  return Select;
}(PureComponent);

export { Select as default };
Select.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  render: PropTypes.func,
  onUpdate: PropTypes.func,
  placement: PropTypes.oneOf(['left', 'right']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  widthAdaptive: PropTypes.bool,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  value: PropTypes.any,
  allowClear: PropTypes.bool,
  messageRender: PropTypes.func,
  disabled: PropTypes.bool,
  operations: PropTypes.array,
  adjustMainSize: PropTypes.number,
  'data-component-name': PropTypes.string,
  noBorder: PropTypes.bool,
  valueKey: PropTypes.any,
  isValueEqual: PropTypes.func
};
Select.defaultProps = {
  id: null,
  className: '',
  render: BasicSelect,
  onUpdate: function onUpdate() {},
  onChange: function onChange() {},
  placement: 'left',
  width: 160,
  widthAdaptive: null,
  placeholder: null,
  size: null,
  value: null,
  allowClear: false,
  messageRender: null,
  disabled: false,
  operations: null,
  adjustMainSize: null,
  'data-component-name': 'Select',
  noBorder: null,
  valueKey: null,
  isValueEqual: function isValueEqual(l, r) {
    return JSON.stringify(l) === JSON.stringify(r);
  }
};